import React from 'react';
import { CssBaseline, ThemeProvider, createTheme, Box } from '@mui/material';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import SplitLayout from './components/Layout/SplitLayout';
import AgentsPage from './components/AgentsPage/AgentsPage';
import DraftsPage from './components/DraftsPage/DraftsPage';
import Navbar from './components/Layout/Navbar';
import { DocumentProvider } from './context/DocumentContext';
import AgentProvider from './context/AgentContext';
import AuthProvider from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute/ProtectedRoute';
import './App.css';
import LoginPage from './components/LoginPage/LoginPage';

const theme = createTheme({
  palette: {
    primary: {
      main: '#1976d2',
    },
    secondary: {
      main: '#dc004e',
    },
    background: {
      default: '#f5f5f5',
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>
        <DocumentProvider>
          <AgentProvider>
            <Router>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  height: '100vh',
                }}
              >
                <Navbar />
                <Box sx={{ flexGrow: 1, overflow: 'auto' }}>
                  <Routes>
                    <Route path="/" element={<LoginPage />} />
                    <Route
                      path="/chat"
                      element={<ProtectedRoute element={<SplitLayout />} />}
                    />
                    <Route
                      path="/drafts"
                      element={<ProtectedRoute element={<DraftsPage />} />}
                    />
                    <Route
                      path="/agents"
                      element={<ProtectedRoute element={<AgentsPage />} />}
                    />
                  </Routes>
                </Box>
              </Box>
            </Router>
          </AgentProvider>
        </DocumentProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
